module.exports = __webpack_public_path__ + "static/media/clock.630fe587.svg";